import { color, color as starryUIColor, Icon, isDownArrow, isEscape, isUpArrow } from '@starrez/starryui9';
import React from 'react';
import styled from 'styled-components';
import { useViewPicker } from '../context/ViewPickerContext';

interface IViewItemIconProps extends IItemIconProps {
    ariaLabel: string;
    ariaExpanded?: boolean;
    ariaHaspopup?: "listbox";
    onClick?: () => void;
    title?: string;
    subItem?: boolean;
}

export const ViewItemIcon = ({ ariaLabel, ariaExpanded, ariaHaspopup, icon, color, onClick, title, subItem }: IViewItemIconProps) => {
    const { closePicker } = useViewPicker();

    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
        if (isUpArrow(e) || isDownArrow(e)) {
            e.stopPropagation();
        } else if (!subItem && isEscape(e)) {
            e.stopPropagation();
            closePicker();
        }
    };

    return (
        <ItemIcon
            type="button"
            aria-label={ariaLabel}
            aria-expanded={ariaExpanded}
            aria-haspopup={ariaHaspopup}
            color={color}
            icon={icon}
            onClick={onClick && onClick}
            title={title}
            onKeyDown={(e) => handleKeyDown(e)}
        >
            <Icon icon={icon} />
        </ItemIcon>
    );
};

interface IItemIconProps {
    color?: string;
    icon: 'StarFilled' | 'StarOutline' | 'CaretRight';
}

export const ItemIcon = styled.button<IItemIconProps>`
    background-color: transparent;
    border: 2px solid transparent;
    cursor: pointer;
    color: ${starryUIColor.Blue.B60};
    padding: 7px;
    border-radius: 4px;
    outline: 0;

    ${({ color }) =>
        color &&
        `
        color: ${color};
    `}

    ${({ color, icon }) =>
        color &&
        icon === 'StarOutline' &&
        `
        &:hover,
        &:focus {
            color: ${starryUIColor.Blue.B60};
        }
    `}

    ${({ color, icon }) =>
        color &&
        icon === 'StarFilled' &&
        `
        color: ${starryUIColor.Blue.B60};
    `}

    &:hover {
        background: ${color.Blue.B20};
    }

    &:focus {
        box-shadow: 0 0 0 2px ${color.Blue.B80};
        border-radius: 4px;
    }
`;
